module.exports = __webpack_public_path__ + "img/box-arrow-down-right.d2e60a7c.svg";